<template>
  <div>
    <!-- 列配置组件 -->
    <column-configurator
      v-if="elementSetting.selectedTablePrintElement"
      :visible.sync="showDialog"
      :columns.sync="elementSetting.selectedTablePrintElement.options.column[0]"
      @confirm="handleColumnsConfirm"
      @cancel="handleColumnsCancel"
      @click.native.stop=""
    />
    <div class="print-setting-box" @click="stopPropagation">
      <div class="title">设置</div>
      <!-- panel设置 -->
      <div
        class="panel-setting-box"
        v-if="
          printHistory.historys.length &&
          !elementSetting.selectedBasePrintElement &&
          !elementSetting.selectedTablePrintElement
        "
      >
        <ul>
          <li>
            <span>页眉(pt)</span>
            <el-input-number
              class="input"
              v-model.number="panel.paperHeader"
              controls-position="right"
              size="mini"
              @change="changepaperHeader"
            ></el-input-number>
          </li>
          <li>
            <span>页脚(pt)</span>
            <el-input-number
              class="input"
              v-model.number="panel.paperFooter"
              controls-position="right"
              @change="changePaperFooter"
              size="mini"
            ></el-input-number>
          </li>
          <li>
            <span>小票打印</span>
            <el-switch
              v-model="panel.panelPageRule"
              :active-value="'none'"
              :inactive-value="null"
              @change="changePanelPageRule"
            ></el-switch>
          </li>
          <li>
            <span>禁用页码</span>
            <el-switch
              v-model="panel.paperNumberDisabled"
              :active-value="true"
              :inactive-value="false"
              @change="changepaperNumberDisabled"
            ></el-switch>
          </li>
          <li>
            <span>手机平台</span>
            <el-switch
              v-model="panel.platform"
              :active-value="true"
              :inactive-value="undefined"
              @change="changePlatform"
            ></el-switch>
          </li>
          <li>
            <span>页码格式</span>
            <el-select
              class="input"
              v-model="panel.paperNumberFormat"
              size="mini"
              @change="changepaperNumberFormat"
            >
              <el-option
                v-for="item in paperNumberFormatList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li>
            <span>水平偏移(mm)</span>
            <div class="input">
              <el-input-number
                v-model="setMyOffsetX"
                controls-position="right"
                :min="-50"
                :max="50"
                size="mini"
                style="margin-left: 20px"
              ></el-input-number>
            </div>
          </li>
          <li>
            <span>垂直偏移(mm)</span>
            <div class="input">
              <el-input-number
                v-model="setMyOffsetY"
                controls-position="right"
                :min="-50"
                :max="50"
                size="mini"
                style="margin-left: 20px"
              ></el-input-number>
            </div>
          </li>
          <li
            style="height: auto"
            v-if="sourceUrl != '/hiPrint/getHiPrintResourceByCatId/label'"
          >
            <span>页边距(mm)</span>
            <div class="input" style="vertical-align: top; height: auto">
              <span style="width: 180px"
                >上
                <el-input-number
                  v-model="setPageTop"
                  controls-position="right"
                  :min="0"
                  :max="10"
                  size="mini"
                  style="margin-left: 5px"
                ></el-input-number
              ></span>
              <span style="width: 180px"
                >下
                <el-input-number
                  v-model="setPageBottom"
                  controls-position="right"
                  :min="0"
                  :max="10"
                  size="mini"
                  style="margin-left: 5px"
                ></el-input-number
              ></span>
              <span style="width: 180px"
                >左
                <el-input-number
                  v-model="setPageLeft"
                  controls-position="right"
                  :min="4"
                  :max="10"
                  size="mini"
                  style="margin-left: 5px"
                ></el-input-number
              ></span>
              <span style="width: 180px"
                >右
                <el-input-number
                  v-model="setPageRight"
                  controls-position="right"
                  :min="4"
                  :max="10"
                  size="mini"
                  style="margin-left: 5px"
                ></el-input-number
              ></span>
            </div>
          </li>
        </ul>

        <div class="page-setting">
          <span class="page-title">每页设置</span>
          <div class="item">
            <el-checkbox
              v-model="panel.displayTableTop"
              @change="changePanelDisplayTableTop"
              >每页打印明细表上方信息</el-checkbox
            >
          </div>
          <div class="item">
            <el-checkbox
              v-model="panel.displayTableBottom"
              @change="changePanelDisplayTableBottom"
              >每页打印明细表下方信息</el-checkbox
            >
          </div>
        </div>
      </div>
      <!-- 文本设置 -->
      <div
        class="element-setting-box"
        v-if="
          printHistory.historys.length &&
          elementSetting.selectedBasePrintElement &&
          !elementSetting.selectedTablePrintElement
        "
      >
        <ul>
          <!-- 线段 -->

          <!-- 长文本 -->
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
              'longText'
            "
            style="height: auto"
          >
            <span>名称</span>
            <el-input
              class="input"
              v-model="elementSetting.selectedBasePrintElement.options.title"
              size="mini"
              type="textarea"
              :rows="3"
              @change="changeTitle"
              style="vertical-align: top"
            ></el-input>
          </li>
          <!-- 文本 -->
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'longText' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'vline'
            "
            style="height: auto"
          >
            <span>名称</span>
            <el-input
              class="input"
              v-model="elementSetting.selectedBasePrintElement.options.title"
              size="mini"
              type="textarea"
              :rows="3"
              @change="changeTitle"
              style="vertical-align: top"
            ></el-input>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'vline'
            "
          >
            <span>取值</span>
            <el-input
              class="input"
              v-model="elementSetting.selectedBasePrintElement.options.testData"
              size="mini"
              disabled
            ></el-input>
          </li>

          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline'
            "
          >
            <span>隐藏名称</span>
            <el-switch
              v-model="
                elementSetting.selectedBasePrintElement.options.hideTitle
              "
              size="mini"
              @change="
                elementSetting.selectedBasePrintElement.updateDesignViewFromOptions()
              "
            ></el-switch>
          </li>
         <!-- <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline'
            ">
            <span>打印类型</span>

            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.textType
              "
              size="mini"
              @change="elementSetting.selectedBasePrintElement.updateDesignViewFromOptions()"
            >
              <el-option 
                label="默认"
                :value="undefined"
              ></el-option>
              <el-option 
                label="文本"
                value="text"
              ></el-option>
              <el-option 
                label="条形码"
                value="barcode"
              ></el-option>
              <el-option 
                label="二维码"
                value="qrcode"
              ></el-option>
            </el-select>
          </li>-->
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.options.top <
                printHistory.historys[0].panels[0].paperHeader
            "
          >
            <span>首页显示</span>
            <el-switch
              v-model="
                elementSetting.selectedBasePrintElement.options.showInPage
              "
              size="mini"
              :active-value="'first'"
              :inactive-value="undefined"
              @change="
                elementSetting.selectedBasePrintElement.updateDesignViewFromOptions()
              "
            ></el-switch>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'image' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'vline'
            "
          >
            <span>更换图片</span>
            <div class="input">
              <el-upload
                action="/api/oss/uploadImg"
                auto-upload
                :on-success="changeImage"
                :on-error="changeImageError"
                :headers="headers"
              >
                <el-button size="small" type="primary">点击上传</el-button>
              </el-upload>
            </div>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'vline'
            "
          >
            <span>宽度(pt)</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.width
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'hline' &&
              elementSetting.selectedBasePrintElement.printElementType.type !=
                'vline'
            "
          >
            <span>高度(pt)</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.height
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
              'hline'
            "
          >
            <span>长度(pt)</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.width
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
              'vline'
            "
          >
            <span>长度(pt)</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.height
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'hline' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'vline'
            "
          >
            <span>线性</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.borderStyle
              "
              size="mini"
              @change="changeBorder"
            >
              <el-option
                v-for="item in borderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'hline' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'vline'
            "
          >
            <span>粗细</span>
            <div class="input">
              <el-input-number
                v-model="
                  elementSetting.selectedBasePrintElement.options.borderWidth
                "
                controls-position="right"
                :min="1"
                :max="10"
                size="mini"
                @change="changeBorder"
              ></el-input-number>
            </div>
          </li>

          <li>
            <span>水平位置</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.left
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li>
            <span>垂直位置</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedBasePrintElement.options.top
              "
              controls-position="right"
              @change="changeSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <!-- 字间距 行高 -->
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>字间距</span>
            <div class="input">
              <el-input-number
                v-model="
                  elementSetting.selectedBasePrintElement.options.letterSpacing
                "
                controls-position="right"
                :min="0"
                :max="10"
                size="mini"
                @change="changeBase"
              ></el-input-number>
            </div>
          </li>
          <li
            v-if="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>行高</span>
            <div class="input">
              <el-input-number
                :value="
                  (elementSetting.selectedBasePrintElement.options.lineHeight ||
                    elementSetting.selectedBasePrintElement.options.fontSize) /
                  elementSetting.selectedBasePrintElement.options.fontSize
                "
                controls-position="right"
                :min="0"
                :max="3"
                :step="0.1"
                size="mini"
                @change="changelineHeight"
              ></el-input-number>
            </div>
          </li>

          <!-- 日期 -->
          <li>
            <span>启用日期</span>
            <el-switch
              v-model="elementSetting.selectedBasePrintElement.options.dataType"
              size="mini"
              :active-value="'datetime'"
              :inactive-value="undefined"
              @change="enableDateType"
            ></el-switch>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.options.dataType ==
              'datetime'
            "
          >
            <span>日期格式</span>
            <el-select
              class="input date-intput"
              v-model="elementSetting.selectedBasePrintElement.options.format"
              size="mini"
              @change="chageDateFormat"
            >
              <el-option
                class="date-intput"
                v-for="item in dateFormatList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>左边框</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.borderLeft
              "
              size="mini"
              @change="changeBorder"
            >
              <el-option
                v-for="item in borderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>上边框</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.borderTop
              "
              size="mini"
              @change="changeBorder"
            >
              <el-option
                v-for="item in borderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>右边框</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.borderRight
              "
              size="mini"
              @change="changeBorder"
            >
              <el-option
                v-for="item in borderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>下边框</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedBasePrintElement.options.borderBottom
              "
              size="mini"
              @change="changeBorder"
            >
              <el-option
                v-for="item in borderList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li
            v-show="
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'text' ||
              elementSetting.selectedBasePrintElement.printElementType.type ==
                'longText'
            "
          >
            <span>边框大小</span>
            <div class="input">
              <el-input-number
                v-model="
                  elementSetting.selectedBasePrintElement.options.borderWidth
                "
                controls-position="right"
                :min="0.75"
                :max="6.75"
                size="mini"
                @change="changeBorder"
              ></el-input-number>
            </div>
          </li>
          <li>
            <span><el-button
                size="mini"
                style="font-weight: bold"
                type="danger"
                @click="deleteElement"
                >删除</el-button
              ></span>
            <div class="input">
              
            </div>
          </li>
        </ul>
      </div>
      <!-- 表格设置 -->
      <div
        class="element-setting-box"
        v-if="
          printHistory.historys.length &&
          !elementSetting.selectedBasePrintElement &&
          elementSetting.selectedTablePrintElement
        "
      >
        <ul>
          <li>
            <span>选择列</span>
            <div class="input">
              <el-button
                size="mini"
                style="font-weight: bold"
                @click="changeShowDialog"
                >点击选择列</el-button
              >
            </div>
          </li>
          <li v-if="elementSetting.selectedColumn">
            <span>列名称</span>
            <el-input
              class="input"
              v-model="elementSetting.selectedColumn.title"
              size="mini"
              @change="changeTableColumnTitle"
            ></el-input>
          </li>
          <li
            v-if="
              elementSetting.selectedColumn &&
              elementSetting.selectedColumn.columnId == 'barcode'
            "
          >
            <span>条码显示</span>
            <el-switch
              v-model="elementSetting.selectedTablePrintElement.options.barcode"
              size="mini"
              @change="changeBarcode"
            ></el-switch>
          </li>
          <li
          v-if="
              elementSetting.selectedColumn &&
              elementSetting.selectedColumn.columnId == 'barcode'
            ">
            <span>字段类型</span>

            <el-select
             
              v-model="elementSetting.selectedTablePrintElement.options.barcode"
              size="mini"
              @change="changeBarcode"
            >
              <el-option 
                label="默认"
                :value="undefined"
              ></el-option>
              <el-option 
                label="文本"
                value="text"
              ></el-option>
              <el-option 
                label="条形码"
                value="barcode"
              ></el-option>
              <el-option 
                label="二维码"
                value="qrcode"
              ></el-option>
            </el-select>
          </li>
          <li v-if="elementSetting.selectedColumn">
            <span>宽度(pt)</span>
            <el-input-number
              class="input"
              v-model.number="elementSetting.selectedColumn.width"
              controls-position="right"
              @change="changeTableSizeOrOption"
              size="mini"
            ></el-input-number>
          </li>
          <li v-if="elementSetting.selectedColumn">
            <span>对齐方式</span>
            <div class="input" style="text-align: left">
              <el-tooltip effect="dark" content="居左" placement="bottom">
                <el-button
                  class="iconfont icon-align-left"
                  :class="{
                    active:
                      elementSetting.selectedColumn.align == 'left' ||
                      (!elementSetting.selectedColumn.align &&
                        elementSetting.selectedTablePrintElement.options
                          .textAlign == 'left'),
                  }"
                  @click="changeTextAlign('left')"
                ></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="居中" placement="bottom">
                <el-button
                  class="iconfont icon-align-center"
                  :class="{
                    active:
                      elementSetting.selectedColumn.align == 'center' ||
                      (!elementSetting.selectedColumn.align &&
                        elementSetting.selectedTablePrintElement.options
                          .textAlign == 'center'),
                  }"
                  @click="changeTextAlign('center')"
                ></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="居右" placement="bottom">
                <el-button
                  class="iconfont icon-align-right"
                  :class="{
                    active:
                      elementSetting.selectedColumn.align == 'right' ||
                      (!elementSetting.selectedColumn.align &&
                        elementSetting.selectedTablePrintElement.options
                          .textAlign == 'right'),
                  }"
                  @click="changeTextAlign('right')"
                ></el-button>
              </el-tooltip>
            </div>
          </li>
          <li>
            <span>表头高度</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedTablePrintElement.options
                  .tableHeaderRowHeight
              "
              controls-position="right"
              size="mini"
              @change="changeTableHeaderRowHeight"
            ></el-input-number>
          </li>
          <li>
            <span>表体高度</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedTablePrintElement.options
                  .tableBodyRowHeight
              "
              controls-position="right"
              size="mini"
              @change="changeTableBodyRowHeight"
            ></el-input-number>
          </li>
          <li>
            <span>最大行数</span>
            <el-input-number
              class="input"
              v-model.number="
                elementSetting.selectedTablePrintElement.options.maxRows
              "
              controls-position="right"
              size="mini"
              @change="changeMaxRows"
            ></el-input-number>
          </li>
          <li>
            <span>表格头显示</span>
            <el-select
              class="input"
              v-model="
                elementSetting.selectedTablePrintElement.options.tableHeaderRepeat
              "
              size="mini"
              @change="changeTableHeaderRepeat"
            >
              <el-option
                v-for="item in tableHeaderRepeatList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li>
            <span>自动补全</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options.autoCompletion
              "
              size="mini"
              :active-value="true"
              :inactive-value="undefined"
              @change="changeMaxRows"
            ></el-switch>
          </li>
          <li>
            <span>金额小数位</span>

            <el-select
              class="input"
              v-model="
                elementSetting.selectedTablePrintElement.options.littlePoint
              "
              size="mini"
              @change="changeLittlePoint"
            >
              <el-option
                v-for="item in littlePointList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li>
            <span>数量小数位</span>

            <el-select
              class="input"
              v-model="
                elementSetting.selectedTablePrintElement.options.quantityLittlePoint
              "
              size="mini"
              @change="changeQuantityLittlePoint"
            >
              <el-option
                v-for="item in quantityLittlePointList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </li>
          <li>
            <span>小计</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options.tableCompute1
              "
              size="mini"
              @change="changeTableCompute1"
            ></el-switch>
          </li>
          <li>
            <span>合计</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options.tableCompute2
              "
              size="mini"
              @change="changeTableCompute2"
            ></el-switch>
          </li>
          <li>
            <span>金额大写</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options.computeUpState
              "
              size="mini"
              @change="changeComputeUpState"
            ></el-switch>
          </li>
          <li>
            <span>数量合计</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options
                  .tableComputeNumberState
              "
              size="mini"
              @change="changeTableComputeNumberState"
            ></el-switch>
          </li>
          <li>
            <span>小票表格</span>
            <el-switch
              v-model="
                elementSetting.selectedTablePrintElement.options.tableStyle
              "
              size="mini"
              @change="changeTableStyle"
              active-value="style2"
              inactive-value="style1"
            ></el-switch>
          </li>
          <li>
            <span><el-button
                size="mini"
                style="font-weight: bold"
                type="danger"
                @click="deleteElement"
                >删除</el-button
              ></span>
            <div class="input">
              
            </div>
          </li>
        </ul>
      </div>
      <div v-else></div>
    </div>
  </div>
</template>

<script>
import ColumnConfigurator from "@/components/ColumnConfigurator";
import { mapGetters, mapState } from "vuex";
export default {
  name: "PrintSetingAside",
  data() {
    return {
      panel: {
        paperHeader: 0,
        paperFooter: 297,
        paperNumberDisabled: false,
        paperNumberFormat: "paperNo-paperCount",
        displayTableTop: false,
        displayTableBottom: false,
        panelPageRule: "",
        platform: undefined,
      },
      textElement: {
        name: "",
        value: "",
        width: 0,
        height: 0,
        left: 0,
        top: 0,
      },
      paperNumberFormatList: [
        {
          value: "paperNo-paperCount",
          label: "页码-页数",
        },
        {
          value: "paperNo",
          label: "页码",
        },
        {
          value: "paperNo/paperCount",
          label: "页码/页数",
        },
        {
          value: "第paperNo页/共paperCount页",
          label: "第1页/共1页",
        },
        {
          value: "第paperNo页",
          label: "第1页",
        },
      ],
      dateFormatList: [
        {
          value: "2025年2月11日 17时51分55秒",
          label: "yyyy年MM月dd日 HH时mm分ss秒",
        },
        {
          value: "yyyy-MM-dd HH:mm:ss",
          label: "2025-02-11 17:51:55",
        },
        {
          value: "yyyy/MM/dd HH:mm:ss",
          label: "2025/02/11 17:51:55",
        },
        {
          value: "yyyy.MM.dd HH:mm:ss",
          label: "2025.02.11 17:51:55",
        },
        {
          value: "yyyy年MM月dd日",
          label: "2025年02月11日",
        },
        {
          value: "yyyy-MM-dd",
          label: "2025-02-11",
        },
        {
          value: "yyyy/MM/dd",
          label: "2025/02/11",
        },
        {
          value: "yyyy.MM.dd",
          label: "2025.02.11",
        },
      ],
      borderList: [
        {
          value: undefined,
          label: "无",
        },
        {
          value: "solid",
          label: "实线",
        },
        {
          value: "dashed",
          label: "虚线",
        },
        {
          value: "dotted",
          label: "点线",
        },
      ],
      littlePointList: [
        {
          value: undefined,
          label: "默认",
        },
        {
          value: -1,
          label: "不限制",
        },
        {
          value: 0,
          label: "0位",
        },
        {
          value: 1,
          label: "1位",
        },
        {
          value: 2,
          label: "2位",
        },
      ],
      quantityLittlePointList: [
        {
          value: undefined,
          label: "默认",
        },
        {
          value: -1,
          label: "不限制",
        },
        {
          value: 0,
          label: "0位",
        },
        {
          value: 1,
          label: "1位",
        },
        {
          value: 2,
          label: "2位",
        },
        {
          value: 3,
          label: "3位",
        },
        {
          value: 4,
          label: "4位",
        },
        {
          value: 5,
          label: "5位",
        },
      ],
      tableHeaderRepeatList: [
        {
          value: undefined,
          label: "默认",
        },
        {
          value: "page",
          label: "每页显示",
        },
        {
          value: "first",
          label: "首页显示",
        }
      ],
      elementSetting: elementSetting,
      printHistory: printHistory,
      showDialog: false,
      idIndex: -1,
      tableindex: -1,
      columnindex: -1,
      hiprintTemplate: {},
    };
  },
  methods: {
    deleteElement() {
      this.$bus.$emit("deleteElement");
    },
    stopPropagation(e) {
      this.$bus.$emit("setting");
      e.stopPropagation();
    },
    changepaperHeader(paperHeader) {
      // printBody中修改
      this.$bus.$emit("changePaperHeader", Number(paperHeader));
    },
    changePaperFooter(paperFooter) {
      // printBody中修改
      this.$bus.$emit("changePaperFooter", Number(paperFooter));
    },
    changepaperNumberDisabled(val) {
      // printBody中修改

      this.$bus.$emit("changePaperNumberDisabled", val);
    },
    
    changepaperNumberFormat(val) {
      console.log(val);
      // printBody中修改
      this.$bus.$emit("changePaperNumberFormat", val);
    },
    changePanelDisplayTableTop(val) {
      // printBody中修改
      this.$bus.$emit("changePanelDisplayTableTop", val);
    },
    changePanelDisplayTableBottom(val) {
      // printBody中修改
      this.$bus.$emit("changePanelDisplayTableBottom", val);
    },
    changePanelPageRule(val) {
      // printBody中修改

      this.$bus.$emit("changePanelPageRule", val);
    },
    changePlatform(val) {
      // printBody中修改
        this.$bus.$emit("changePlatform", val);
    },
    changeSizeOrOption() {
      this.elementSetting.selectedBasePrintElement.updateSizeAndPositionOptions();
      this.$bus.$emit("design");
      this.elementSetting.selectedBasePrintElement.designTarget
        .children("div[panelindex]")
        .css({
          display: "block",
        });
    },
    changeTableSizeOrOption() {
      this.elementSetting.selectedTablePrintElement.options.width =
        this.elementSetting.selectedTablePrintElement.options.columns[0].columns.reduce(
          (total, item) => total + item.width,
          0
        );
      this.elementSetting.selectedTablePrintElement.updateSizeAndPositionOptions();
      this.$bus.$emit("design");
    },
    changeTitle(val) {
      if (
        this.elementSetting.selectedBasePrintElement.options.field &&
        this.elementSetting.selectedBasePrintElement.options.textType !=
          "barcode" &&
        this.elementSetting.selectedBasePrintElement.options.dataType !=
          "datetime"
      ) {
        this.elementSetting.selectedBasePrintElement.options.testData =
          "@" + val;
      }
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    enableDateType(val) {
      if (val == "datetime") {
        this.elementSetting.selectedBasePrintElement.options.testData =
          hinnn.dateFormat(new Date(), "yyyy-M-d HH:mm:ss");
      }

      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    changeImage(response, file, fileList) {
      console.log(response);
      if (response.code == 200 && response.flag == true) {
        this.elementSetting.selectedBasePrintElement.options.src =
          response.data.url;
        this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
      }
    },
    changeImageError() {
      //弹出错误提示
      this.$message.error("上传失败");
    },
    changeTableColumnTitle(val) {
      this.elementSetting.selectedColumn.title = val;
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableTextType(val) {
      this.elementSetting.selectedColumn.tableTextType = val;
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    chageDateFormat() {
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    changeBase() {
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    changelineHeight(val) {
      this.elementSetting.selectedBasePrintElement.options.lineHeight =
        val * this.elementSetting.selectedBasePrintElement.options.fontSize;
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    changeBorder() {
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
    },
    changeBorderTransform() {
      this.elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    changeTableHeaderRowHeight(val) {
      this.changeTableHeight();
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    changeTableBodyRowHeight(val) {
      this.changeTableHeight();
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    changeMaxRows(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableHeaderRepeat(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeLittlePoint(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeQuantityLittlePoint(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableHeight() {
      console.log(
        "height",
        this.elementSetting.selectedTablePrintElement.options.height
      );
      if (
        this.elementSetting.selectedTablePrintElement.options.tableStyle ==
        "style2"
      ) {
        this.elementSetting.selectedTablePrintElement.options.height =
          (this.elementSetting.selectedTablePrintElement.options
            .tableBodyRowHeight || 18) +
          1 +
          this.elementSetting.selectedTablePrintElement.options
            .tableHeaderRowHeight +
          this.elementSetting.selectedTablePrintElement.options
            .tableBodyRowHeight;
      } else {
        let num =
          Number(
            this.elementSetting.selectedTablePrintElement.options.tableCompute1
          ) +
          Number(
            this.elementSetting.selectedTablePrintElement.options.tableCompute2
          );
        this.elementSetting.selectedTablePrintElement.options.height =
          (this.elementSetting.selectedTablePrintElement.options
            .tableBodyRowHeight || 18) *
            num +
          1 +
          this.elementSetting.selectedTablePrintElement.options
            .tableHeaderRowHeight +
          this.elementSetting.selectedTablePrintElement.options
            .tableBodyRowHeight;
      }
      console.log(
        "height",
        this.elementSetting.selectedTablePrintElement.options.height
      );
    },
    changeTableCompute1(val) {
      this.changeTableHeight();
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    changeBarcode() {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTextAlign(align) {
      elementSetting.selectedColumn.align = align;
      elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableCompute2(val) {
      this.changeTableHeight();
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    changeComputeUpState(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableComputeNumberState(val) {
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
    },
    changeTableStyle(val) {
      this.changeTableHeight();
      if (
        this.elementSetting.selectedTablePrintElement.options.tableStyle ==
        "style2"
      ) {
        this.elementSetting.selectedTablePrintElement.options.tableBorder =
          "noBorder";
        this.elementSetting.selectedTablePrintElement.options.tableHeaderCellBorder =
          "noBorder";
        this.elementSetting.selectedTablePrintElement.options.tableBodyCellBorder =
          "noBorder";
        this.elementSetting.selectedTablePrintElement.options.tableBodyRowBorder =
          "noBorder";
        this.elementSetting.selectedTablePrintElement.options.tableHeaderBorder =
          "noBorder";
      } else {
        this.elementSetting.selectedTablePrintElement.options.tableBorder =
          "border";
        this.elementSetting.selectedTablePrintElement.options.tableHeaderCellBorder =
          "border";
        this.elementSetting.selectedTablePrintElement.options.tableBodyCellBorder =
          "border";
        this.elementSetting.selectedTablePrintElement.options.tableBodyRowBorder =
          "border";
        this.elementSetting.selectedTablePrintElement.options.tableHeaderBorder =
          "border";
      }
      this.elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      this.$bus.$emit("design");
    },
    handleColumnsConfirm(column) {
      // 新历史
      let newHistory = JSON.parse(
        JSON.stringify(this.printHistory.historys[0])
      );
      this.$bus.$emit(
        "getidIndex",
        this.elementSetting.selectedTablePrintElement.id
      );

      let tablePrintElement = newHistory.panels[0].printElements[this.idIndex];
      console.log('tablePrintElement',tablePrintElement, this.idIndex);

      // //更新column 与 columns 的内容
      let columnFather = tablePrintElement?.options?.column;
      let columnsFather = tablePrintElement?.options?.columns;
      console.log(columnFather, columnsFather);
      this.$set(columnFather, 0, column);

      let columns = column.filter((item) => item.checked);
      this.$set(columnsFather, 0, columns);

      //更新表格长度
      if (tablePrintElement) {
        tablePrintElement.options.width = columns.reduce(
          (total, item) => total + item.width,
          0
        );
      }
      if (tablePrintElement.options.width > this.maxTableWidth) {
        tablePrintElement.options.width = this.maxTableWidth;
      }
      //表格加个属性标识符
      tablePrintElement.options.isEditing = true;
      //更新历史
      this.printHistory.historys.unshift(newHistory);
       

      //更新设计视图
      this.$bus.$emit("design2");
      this.$bus.$emit("getHiprintTemplate");
      this.$bus.$emit(
        "getidIndexByEditing"
      ); 
      this.elementSetting.selectedTablePrintElement =
        this.hiprintTemplate.editingPanel.printElements[this.idIndex];
      this.elementSetting.selectedTablePrintElement.options.isEditing = null;

      this.printHistory.init1(this.hiprintTemplate);
      console.log(
        "@@@",
        this.elementSetting.selectedColumn,
        this.elementSetting?.selectedColumn?.columnId,
        this.elementSetting.selectedTablePrintElement.options.columns[0]
          .columns,
        this.elementSetting.selectedTablePrintElement.options.columns[0].columns.find(
          (item) =>
            item.columnId == this.elementSetting?.selectedColumn?.columnId
        )
      );
      this.elementSetting.selectedColumn =
        this.elementSetting.selectedTablePrintElement.options.columns[0].columns.find(
          (item) =>
            item.columnId == this.elementSetting?.selectedColumn?.columnId
        );
    },
    handleColumnsCancel() {
      this.showDialog = false;
    },
    changeShowDialog() {
      //首先更新column 与 columns 的内容
      let columns =
        this.elementSetting.selectedTablePrintElement.options.columns[0]
          .columns;
      let column =
        this.elementSetting.selectedTablePrintElement.options.column[0];
      let newColumn1 = [];
      let newColumn2 = [];


      column.forEach((item) => {
        let find = 0;
        columns.forEach((item2, index) => {
          if (
            (item2.field || item2.columnId) == (item.field || item.columnId)
          ) {
            item.width = item2.width;
            item.title = item2.title;
            item.align = item2.align;
            item.checked = true;
            find = 1;
            newColumn1.push(item);
          }
        });
        if (find == 0) {
          item.checked = false;
          newColumn2.push(item);
        }
      });

      this.elementSetting.selectedTablePrintElement.options.column[0] =
        newColumn1.concat(newColumn2);
      console.log(newColumn1);

      this.showDialog = true;
    },
  },
  computed: {
    ...mapGetters(["token", "sourceUrl"]),
    ...mapState([
      "pageTop",
      "pageLeft",
      "pageRight",
      "pageBottom",
      "MyOffsetX",
      "MyOffsetY",
      "maxTableWidth",
    ]),
    headers() {
      return {
        Authorization: "Bearer " + this.token,
      };
    },
    setPageTop: {
      get() {
        console.log("vallllpageTop", this.pageTop);
        return this.pageTop;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.pageTop = val;
        }
      },
    },
    setPageLeft: {
      get() {
        return this.pageLeft;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.pageLeft = val;
        }
      },
    },
    setPageRight: {
      get() {
        return this.pageRight;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.pageRight = val;
        }
      },
    },
    setPageBottom: {
      get() {
        return this.pageBottom;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.pageBottom = val;
        }
      },
    },
    setMyOffsetX: {
      get() {
        return this.MyOffsetX;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.MyOffsetX = val;
        }
      },
    },
    setMyOffsetY: {
      get() {
        return this.MyOffsetY;
      },
      set(val) {
        if (typeof val == "number") {
          this.$store.state.MyOffsetY = val;
        }
      },
    },
  },
  watch: {
    printHistory: {
      handler(printHistory) {
        if (printHistory.historys.length) {
          this.panel.paperHeader =
            printHistory.historys[0].panels[0].paperHeader;
          this.panel.paperFooter =
            printHistory.historys[0].panels[0].paperFooter;
          this.panel.paperNumberDisabled =
            printHistory.historys[0].panels[0].paperNumberDisabled;

          this.panel.paperNumberFormat =
            printHistory.historys[0].panels[0].paperNumberFormat ||
            "paperNo-paperCount";

          this.panel.displayTableTop =
            printHistory.historys[0].panels[0].displayTableTop || false;
          this.panel.displayTableBottom =
            printHistory.historys[0].panels[0].displayTableBottom || false;
          this.panel.panelPageRule =
            printHistory.historys[0].panels[0].panelPageRule;
          this.panel.platform =
            printHistory.historys[0].panels[0].platform;

          //  this.panel.paperNumberDisabled = val.historys[0].panels[0].paperNumberDisabled
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    ColumnConfigurator,
  },
  mounted() {
    this.$bus.$on("index", (index) => {
      this.idIndex = index;
    });
    this.$bus.$on("hiprintTemplate", (hiprintTemplate) => {
      this.hiprintTemplate = hiprintTemplate;
    });
  },
};
</script>
<style scoped>
>>> .date-intput input {
  padding-left: 10px !important;
  padding-right: 0px !important;
}
</style>
<style lang="less" scoped>
.iconfont {
  padding: 0;
  display: inline-block;
  width: 28px;
  height: 25px;
  line-height: 25px;
  vertical-align: middle;
  border-radius: 3px;
  margin: 0 1px;
  &.active {
    background: #409eff;
    color: #fff;
  }
}
.print-setting-box {
  height: 100%;
  font: 14px "微软雅黑";
  .title {
    padding: 10px 20px;
    font: 18px "宋体";
    color: #000;
    background-color: #fff;
    font-weight: 500;
    border-bottom: 2px solid #eee;
    text-align: center;
  }
  .input {
    display: inline-block;
    vertical-align: middle;
    width: 180px;
  }
  ul {
    padding-top: 20px;
  }
  li {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;

    span {
      display: inline-block;
      width: 90px;
      font-size: 14px;
      //不换行
      white-space: nowrap;
    }
  }
  .page-setting {
    padding-left: 10px;
    .page-title {
      height: 40px;
      line-height: 40px;
    }
    .item {
      padding-left: 20px;
    }
  }
}
</style>